import React from "react";

const OrderCreationDirectIcon = ({ color = "#6D7885", ...rest }) => {
  return (
    <svg preserveAspectRatio="none" overflow="visible" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g>
        <path d="M8 12.052C9.995 12.052 11.5 10.547 11.5 8.552C11.5 6.557 9.995 5.052 8 5.052C6.005 5.052 4.5 6.557 4.5 8.552C4.5 10.547 6.005 12.052 8 12.052ZM9 13H7C4.243 13 2 15.243 2 18V19H14V18C14 15.243 11.757 13 9 13ZM20.294 8.292L15.994 12.584L14.702 11.292L13.288 12.706L15.994 15.41L21.706 9.708L20.294 8.292Z" fill={color} />
      </g>
    </svg>
  );
};

export default OrderCreationDirectIcon;
